<template>
  <BaseDialog v-bind="$attrs" size="large" v-model="showDialog">
    <ClientNotificationList class="mt-n2" ref="list" />
  </BaseDialog>
</template>

<script>
import baseDialogMixin from '@/services/baseDialogMixin';
import ClientNotificationList from './ClientNotificationList.vue';
export default {
  mixins: [baseDialogMixin],
  components: {
    ClientNotificationList,
  },
};
</script>

<style lang="scss" scoped></style>
